import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../services/api';

export default function Account() {
  const { user, logout, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!user) { navigate('/login', { replace: true }); return; }
    refreshUser();
    api.getBillingStatus().then(setBilling).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!user) return null;

  const handleManageBilling = async () => {
    setLoading(true);
    try {
      const { url } = await api.createPortalSession();
      window.location.href = url;
    } catch {
      // Stripe portal not available
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isPremium = user.tier === 'premium';

  return (
    <div className="min-h-screen pt-24 px-6 pb-16">
      <div className="max-w-md mx-auto">
        <h1 className="font-serif text-2xl text-warm mb-8">Account</h1>

        <div className="space-y-6">
          {/* Profile */}
          <div className="border border-dark-200/50 rounded-xl p-5">
            <h2 className="text-warm-100/60 text-xs uppercase tracking-wider mb-3">Profile</h2>
            <div className="space-y-2">
              {user.name && <p className="text-warm text-sm">{user.name}</p>}
              <p className="text-warm-100/60 text-sm">{user.email}</p>
            </div>
          </div>

          {/* Subscription */}
          <div className="border border-dark-200/50 rounded-xl p-5">
            <h2 className="text-warm-100/60 text-xs uppercase tracking-wider mb-3">Subscription</h2>
            <div className="flex items-center gap-3 mb-4">
              <span className={`px-3 py-1 rounded-full text-xs ${isPremium ? 'bg-gold/20 text-gold' : 'bg-dark-200 text-warm-100/60'}`}>
                {isPremium ? 'Premium' : 'Free'}
              </span>
              {billing?.subscriptionStatus && (
                <span className="text-warm-100/40 text-xs">{billing.subscriptionStatus}</span>
              )}
            </div>
            {isPremium ? (
              <button
                onClick={handleManageBilling}
                disabled={loading}
                className="text-warm-100/60 text-sm hover:text-warm transition-colors"
              >
                {loading ? 'Opening...' : 'Manage billing'}
              </button>
            ) : (
              <button
                onClick={() => navigate('/pricing')}
                className="bg-gold/15 border border-gold/30 text-gold px-4 py-2 rounded-lg text-sm hover:bg-gold/25 transition-colors"
              >
                Upgrade to Premium
              </button>
            )}
          </div>

          {/* Actions */}
          <button
            onClick={handleLogout}
            className="text-warm-100/40 text-sm hover:text-red-400 transition-colors"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
